import { render, staticRenderFns } from "./CompTableDelta.vue?vue&type=template&id=f8e3e9b4&scoped=true"
import script from "./CompTableDelta.vue?vue&type=script&lang=js"
export * from "./CompTableDelta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8e3e9b4",
  null
  
)

export default component.exports